
// Simple mock data for demonstration
export const countries = [
  { id: 'au', name: 'Australia' },
  { id: 'ca', name: 'Canada' },
  { id: 'in', name: 'India' },
  { id: 'jp', name: 'Japan' },
  { id: 'np', name: 'Nepal' },
  { id: 'uk', name: 'United Kingdom' },
  { id: 'us', name: 'United States' }
].sort((a, b) => a.name.localeCompare(b.name));

export const states = {
  au: [
    { id: 'nsw', name: 'New South Wales' },
    { id: 'qld', name: 'Queensland' },
    { id: 'vic', name: 'Victoria' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  ca: [
    { id: 'bc', name: 'British Columbia' },
    { id: 'on', name: 'Ontario' },
    { id: 'qc', name: 'Quebec' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  in: [
    { id: 'ap', name: 'Andhra Pradesh' },
    { id: 'as', name: 'Assam' },
    { id: 'dl', name: 'Delhi' },
    { id: 'gj', name: 'Gujarat' },
    { id: 'hr', name: 'Haryana' },
    { id: 'ka', name: 'Karnataka' },
    { id: 'kl', name: 'Kerala' },
    { id: 'mh', name: 'Maharashtra' },
    { id: 'mp', name: 'Madhya Pradesh' },
    { id: 'pb', name: 'Punjab' },
    { id: 'rj', name: 'Rajasthan' },
    { id: 'tg', name: 'Telangana' },
    { id: 'tn', name: 'Tamil Nadu' },
    { id: 'up', name: 'Uttar Pradesh' },
    { id: 'wb', name: 'West Bengal' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  np: [
    { id: 'bg', name: 'Bagmati' },
    { id: 'gn', name: 'Gandaki' },
    { id: 'kt', name: 'Karnali' },
    { id: 'lu', name: 'Lumbini' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  uk: [
    { id: 'eng', name: 'England' },
    { id: 'sct', name: 'Scotland' },
    { id: 'wls', name: 'Wales' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  us: [
    { id: 'ca', name: 'California' },
    { id: 'ny', name: 'New York' },
    { id: 'tx', name: 'Texas' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  jp: [
    { id: 'ky', name: 'Kyoto' },
    { id: 'os', name: 'Osaka' },
    { id: 'tk', name: 'Tokyo' }
  ].sort((a, b) => a.name.localeCompare(b.name))
};

export const cities = {
  // Indian cities by state
  ap: [
    { id: 'gun', name: 'Guntur' },
    { id: 'kur', name: 'Kurnool' },
    { id: 'nel', name: 'Nellore' },
    { id: 'vij', name: 'Vijayawada' },
    { id: 'viz', name: 'Visakhapatnam' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  as: [
    { id: 'dib', name: 'Dibrugarh' },
    { id: 'guw', name: 'Guwahati' },
    { id: 'jrt', name: 'Jorhat' },
    { id: 'ngn', name: 'Nagaon' },
    { id: 'sil', name: 'Silchar' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  dl: [
    { id: 'cdl', name: 'Central Delhi' },
    { id: 'edl', name: 'East Delhi' },
    { id: 'ndl', name: 'New Delhi' },
    { id: 'sdl', name: 'South Delhi' },
    { id: 'wdl', name: 'West Delhi' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  gj: [
    { id: 'amd', name: 'Ahmedabad' },
    { id: 'bhv', name: 'Bhavnagar' },
    { id: 'raj', name: 'Rajkot' },
    { id: 'sur', name: 'Surat' },
    { id: 'vad', name: 'Vadodara' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  hr: [
    { id: 'amb', name: 'Ambala' },
    { id: 'fbd', name: 'Faridabad' },
    { id: 'gur', name: 'Gurugram' },
    { id: 'knl', name: 'Karnal' },
    { id: 'pnc', name: 'Panipat' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  ka: [
    { id: 'bel', name: 'Belagavi' },
    { id: 'blr', name: 'Bengaluru' },
    { id: 'hub', name: 'Hubballi' },
    { id: 'man', name: 'Mangaluru' },
    { id: 'mys', name: 'Mysuru' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  kl: [
    { id: 'knn', name: 'Kannur' },
    { id: 'koc', name: 'Kochi' },
    { id: 'kzk', name: 'Kozhikode' },
    { id: 'thr', name: 'Thrissur' },
    { id: 'tvm', name: 'Thiruvananthapuram' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  mh: [
    { id: 'aur', name: 'Aurangabad' },
    { id: 'mum', name: 'Mumbai' },
    { id: 'nag', name: 'Nagpur' },
    { id: 'pun', name: 'Pune' },
    { id: 'tha', name: 'Thane' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  mp: [
    { id: 'bpl', name: 'Bhopal' },
    { id: 'gwl', name: 'Gwalior' },
    { id: 'ind', name: 'Indore' },
    { id: 'jbp', name: 'Jabalpur' },
    { id: 'ujn', name: 'Ujjain' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  pb: [
    { id: 'asr', name: 'Amritsar' },
    { id: 'bth', name: 'Bathinda' },
    { id: 'jld', name: 'Jalandhar' },
    { id: 'ldh', name: 'Ludhiana' },
    { id: 'ptl', name: 'Patiala' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  rj: [
    { id: 'ajm', name: 'Ajmer' },
    { id: 'bkn', name: 'Bikaner' },
    { id: 'jdp', name: 'Jodhpur' },
    { id: 'jpr', name: 'Jaipur' },
    { id: 'kot', name: 'Kota' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  tg: [
    { id: 'hyd', name: 'Hyderabad' },
    { id: 'kha', name: 'Khammam' },
    { id: 'krm', name: 'Karimnagar' },
    { id: 'nzb', name: 'Nizamabad' },
    { id: 'wgl', name: 'Warangal' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  tn: [
    { id: 'cbe', name: 'Coimbatore' },
    { id: 'chn', name: 'Chennai' },
    { id: 'mdu', name: 'Madurai' },
    { id: 'slm', name: 'Salem' },
    { id: 'trc', name: 'Tiruchirappalli' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  up: [
    { id: 'agr', name: 'Agra' },
    { id: 'gbd', name: 'Ghaziabad' },
    { id: 'knp', name: 'Kanpur' },
    { id: 'lko', name: 'Lucknow' },
    { id: 'vns', name: 'Varanasi' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  wb: [
    { id: 'asp', name: 'Asansol' },
    { id: 'dur', name: 'Durgapur' },
    { id: 'hlg', name: 'Howrah' },
    { id: 'kol', name: 'Kolkata' },
    { id: 'sil', name: 'Siliguri' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  // US cities
  ca: [
    { id: 'la', name: 'Los Angeles' },
    { id: 'sd', name: 'San Diego' },
    { id: 'sf', name: 'San Francisco' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  ny: [
    { id: 'buf', name: 'Buffalo' },
    { id: 'nyc', name: 'New York City' },
    { id: 'roc', name: 'Rochester' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  tx: [
    { id: 'aus', name: 'Austin' },
    { id: 'dal', name: 'Dallas' },
    { id: 'hou', name: 'Houston' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  // Canadian cities
  on: [
    { id: 'ham', name: 'Hamilton' },
    { id: 'ott', name: 'Ottawa' },
    { id: 'tor', name: 'Toronto' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  bc: [
    { id: 'kel', name: 'Kelowna' },
    { id: 'van', name: 'Vancouver' },
    { id: 'vic', name: 'Victoria' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  qc: [
    { id: 'gat', name: 'Gatineau' },
    { id: 'mtl', name: 'Montreal' },
    { id: 'qbc', name: 'Quebec City' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  // UK cities
  eng: [
    { id: 'brm', name: 'Birmingham' },
    { id: 'lon', name: 'London' },
    { id: 'mcr', name: 'Manchester' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  sct: [
    { id: 'abd', name: 'Aberdeen' },
    { id: 'edi', name: 'Edinburgh' },
    { id: 'gla', name: 'Glasgow' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  wls: [
    { id: 'cdf', name: 'Cardiff' },
    { id: 'npt', name: 'Newport' },
    { id: 'swn', name: 'Swansea' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  // Nepal cities
  bg: [
    { id: 'bkt', name: 'Bhaktapur' },
    { id: 'ktm', name: 'Kathmandu' },
    { id: 'llt', name: 'Lalitpur' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  lu: [
    { id: 'but', name: 'Butwal' },
    { id: 'sid', name: 'Siddharthanagar' },
    { id: 'tlp', name: 'Tilottama' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  kt: [
    { id: 'brn', name: 'Birendranagar' },
    { id: 'dai', name: 'Dailekh' },
    { id: 'jum', name: 'Jumla' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  gn: [
    { id: 'bgl', name: 'Baglung' },
    { id: 'gkh', name: 'Gorkha' },
    { id: 'pkh', name: 'Pokhara' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  // Australian cities
  nsw: [
    { id: 'new', name: 'Newcastle' },
    { id: 'syd', name: 'Sydney' },
    { id: 'wol', name: 'Wollongong' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  qld: [
    { id: 'bri', name: 'Brisbane' },
    { id: 'cai', name: 'Cairns' },
    { id: 'gld', name: 'Gold Coast' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  vic: [
    { id: 'bal', name: 'Ballarat' },
    { id: 'gee', name: 'Geelong' },
    { id: 'mel', name: 'Melbourne' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  // Japanese cities
  tk: [
    { id: 'min', name: 'Minato' },
    { id: 'shb', name: 'Shibuya' },
    { id: 'shj', name: 'Shinjuku' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  os: [
    { id: 'nan', name: 'Namba' },
    { id: 'ten', name: 'Tennoji' },
    { id: 'umk', name: 'Umeda Kita' }
  ].sort((a, b) => a.name.localeCompare(b.name)),
  ky: [
    { id: 'nak', name: 'Nakagyo' },
    { id: 'sak', name: 'Sakyo' },
    { id: 'ukk', name: 'Ukyo' }
  ].sort((a, b) => a.name.localeCompare(b.name))
};

